module.exports = __webpack_public_path__ + "components/flag/static/square/bi-ff8c04d5440f7f861d75b326727298d3.svg";